import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import { Flex, Padding, Margin } from 'components/base/layout-components';
import Text, { Inline } from 'components/base/Text';

export const RadioboxGroup = ({
  title = null,
  description,
  value,
  setValue,
  isRequired = false,
  disabled = false,
  options = [] // should be an array of objects and each object contains 'name' and 'value' keys
}) => {
  return (
    <Flex mb='small' direction='column'>
      {title && (
        <Flex mb='x-small'>
          <Text textTransform='uppercase' mb='small' size='medium'>
            {isRequired && (
              <Inline size='medium' color='radicalRed'>
                *{' '}
              </Inline>
            )}
            {title}
          </Text>
        </Flex>
      )}

      <Flex>
        <Text size='medium' lineHeight='2rem' width='90%' color='shuttleGray'>
          {description}
        </Text>
      </Flex>
      <Padding l='small'>
        <RadioGroup
          row
          onChange={e => setValue(e.target.value)}
          defaultValue={value}
          value={value}
        >
          <Margin r='medium'>
            {options.map(option => (
              <FormControlLabel
                key={option.value}
                disabled={disabled}
                value={option.value}
                control={<Radio color='primary' />}
                label={
                  <Text size='medium' color='shuttleGray'>
                    {option.name}
                  </Text>
                }
              />
            ))}
          </Margin>
        </RadioGroup>
      </Padding>
    </Flex>
  );
};
